var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29674 10.4544L11.5728 14.2775C11.6256 14.3391 11.6911 14.3885 11.7649 14.4224C11.8386 14.4563 11.9187 14.4738 11.9999 14.4738C12.081 14.4738 12.1612 14.4563 12.2349 14.4224C12.3086 14.3885 12.3741 14.3391 12.4269 14.2775L15.703 10.4544C16.0156 10.0894 15.7564 9.52576 15.276 9.52576H8.72283C8.24236 9.52576 7.98315 10.0894 8.29674 10.4544Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.0727942cc9e715c9f984fc303de16565.svg";
export { ForwardRef as ReactComponent };